import classNames from 'clsx';
import React from 'react';

import StarsButton from '@swf/components/StarsButton/StarsButton';

import { TXTWCL_Buy, TXTWCL_Collect_XbXN0X_bX } from './Action.messages.json';
import styles from './Action.scss';

interface Props {
  price: number;
  balance: number;
  showCollect: boolean;
  onClick?(): void;
}

// TODO: refactor button tracking to accept values
const Action: React.FC<Props> = ({ onClick, price, balance, showCollect }) =>
  balance < price ? (
    <StarsButton
      onClick={onClick}
      disabled={showCollect}
      variant="casino"
      className={classNames(styles.button, showCollect && styles.collectButton)}
      translation={showCollect ? TXTWCL_Collect_XbXN0X_bX : TXTWCL_Buy}
      values={{ 0: price - balance, b: (text: string) => text }}
    />
  ) : (
    <StarsButton onClick={onClick} className={styles.button} translation={TXTWCL_Buy} />
  );

export default Action;
